export default __webpack_public_path__ + "static/media/jaguar.53d43b9e.svg";